{
	"DeviceHint": "Select the supervisors endpoint to allow the built-in browser-based call controls",
	"OmnichannelAgent": "Omnichannel Agent:",
	"NoneSelected": "[None Selected]",
	"NoAssociatedDevice": "[No Associated Device]",
	"NoAssociatedAgent": "[No Associated ACD Agent]",
	"NAME": "ExtensionEndpoint",
	"ExtensionEndpoint_PermissionsNote": "Set user access level permissions.",
	"ExtensionEndpoint_CmEnvironment": "CME:",
	"ExtensionEndpoint_TelServer": "Telephony Server:",
	"ExtensionEndpoint_Partition": "Partition:",
	"ExtensionEndpoint_Device": "Device:",
	"ExtensionEndpoint_AndOrAgent": "And/or Agent:",
	"ExtensionEndpoint_Validation_Professional_Device": "A Professional user must have a device endpoint set",
	"ExtensionEndpoint_Validation_Professional_Device_MST": "A CXA Unused user must have a device endpoint set",
	"ExtensionEndpoint_Validation_CallCentreAgent_Agent": "A Call Centre Agent must have a agent endpoint set",
	"ExtensionEndpoint_Validation_CallCentreAgent_Agent_MST": "A CXA Premium user must have an agent endpoint set"
}